import React from 'react';
import {
  MdBarChart,
  MdDataThresholding,
  MdSearch,
  MdSecurityUpdateGood,
} from 'react-icons/md';
import LandinPix from '../Assets/Image/Landingpix.png';

export const Benefit = () => {
  const benefit = [
    {
      id: 1,
      icon: <MdSearch />,
      title: 'No Hidden Fees',
      description:
        'Our rates and charges are the most competitive in the market.',
    },
    {
      id: 2,
      icon: <MdSecurityUpdateGood />,
      title: 'Secure Trusted',
      description:
        'Every transaction is secured with state of the art encryption',
    },
    {
      id: 3,
      icon: <MdDataThresholding />,
      title: 'Instant Trading',
      description: 'Fast and efficient transactions.',
    },
    {
      id: 4,
      icon: <MdBarChart />,
      title: 'Exclusive',
      description:
        'An Exclusive and prescreened user base to ensure integrity, trust and loyalty backed by secure workflows',
    },
  ];

  return (
    <section className='px-4 sm:px-10 lg:px-20'>
      <div className='mx-auto gap-12 max-w-[1440px] flex flex-col'>
        <div className='space-y-2'>
          <h3 className='text-b-mc '>BENEFIT</h3>
          <h2 className='text-2xl font-semibold'>What We Offer</h2>
        </div>
        <div className='gap-x-20 gap-y-10 w-full grid lg:grid-cols-2'>
          <img
            src={LandinPix}
            alt='benefit-img'
            className='w- flex items-center col-span-1 w-full object-cover'
          />
          <div className='flex flex-col gap-4 col-span-1'>
            {benefit.map((data) => (
              <div key={data.id} className='flex gap-4'>
                <span className='text-4xl text-b-mc '>{data.icon}</span>
                <div>
                  <h1 className='font-semibold text-xl'>{data.title}</h1>
                  <p>{data.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
